// extracted by mini-css-extract-plugin
module.exports = {"container":"paginator_container__lvUMf","paginationBtn":"paginator_paginationBtn__7mvZ9","pageBtn":"paginator_pageBtn__jOeX2","pageBtnSelected":"paginator_pageBtnSelected__RYEMK"};